(function($){

    $('.muza-register form').on('submit', function(e){
        e.preventDefault();
        muza_register();
    })


    function muza_register() {
        $('.muza-register form .alerts').removeClass('error success');
        $('.muza-register form .alerts').slideUp(500);
        var button_text = $('.muza-register form button').html(), int;
        $.ajax({
            url: ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'muza_register',
                'data': $('.muza-register form').serialize(),
                'nonce': ajax_obj.nonce
            },
            beforeSend: function beforeSend(errorThrown) {
                $('.muza-register form button').addClass('disabled');
                $('.muza-register form button').html('.')
                int = setInterval(function(){
                    $('.muza-register form button').html($('.muza-register form button').html() + '.');
                }, 1200)
            },
            success: function success(data) {
                clearInterval(int);
                $('.muza-register form button').html(button_text);
                $('.muza-register form button').removeClass('disabled');
                try{
                    var result = $.parseJSON(data);
                    $('.muza-register form .alerts').addClass(result['status']);
                    $('.muza-register form .alerts').html(result['message']).slideDown(500);
                    if(result['status'] == 'success'){
                        window.location.href = result['redirectUri'];
                    }
                }
                catch(e){
                    alert('Wystąpił jakiś błąd, spróbuj ponownie później.');
                }
            },
            error: function error(errorThrown) {
                console.log(errorThrown);
            }
        });
    }
})(jQuery)
